// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class ApiMintingClaimAction {
    /**
    * Contract-specific minting claim action name
    */
    'action': string;
    'completed': boolean;
    /**
    * Unix epoch milliseconds when this action record was created
    */
    'created_at'?: number;
    /**
    * Unix epoch milliseconds when this action record was last updated
    */
    'updated_at'?: number;
    'created_by_wallet'?: string;
    'updated_by_wallet'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "action",
            "baseName": "action",
            "type": "string",
            "format": ""
        },
        {
            "name": "completed",
            "baseName": "completed",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "created_at",
            "baseName": "created_at",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "updated_at",
            "baseName": "updated_at",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "created_by_wallet",
            "baseName": "created_by_wallet",
            "type": "string",
            "format": ""
        },
        {
            "name": "updated_by_wallet",
            "baseName": "updated_by_wallet",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiMintingClaimAction.attributeTypeMap;
    }

    public constructor() {
    }
}

